import cleanupNonCurrentCustomer from 'actions/customer/lib/cleanup_non_current_customer';

export function cleanUpActiveSession(context, session) {
  context.stores.activeSessions.remove(session.id);
  context.gateways.routingQueueItem.unsubscribe(session.id);
  context.gateways.customerTypingState.unsubscribe(session.customer.id);

  cleanupNonCurrentCustomer(context, session.customer.id);
}
